import { ActionType } from "../../schemas/Home/Home.schema";
import { put, call } from "redux-saga/effects";
import { showLoading, hideLoading } from "../../actions/Login/action";
import { DomainConverter } from "../../utils/common";
import {
  capacityListSuccess,
  getCapacityLoadsSuccess,
  manageCapacityRemoveSuccess,
  manageCapacityUpdateSuccess
} from "../../actions/manage/action";
import request from "../../utils/request";

const APPLICATION_JSON = "application/json";

/**
 *  Get Manage Capacity List
 *
 * @param action
 */
export function* getManageCapaityList(action: ActionType): any {
  const { query, isRefresh , isPullToRefresh, callback } = action.payload as any;
  try {
    if(isPullToRefresh !== undefined) yield put(showLoading(isPullToRefresh));
    const queryValue = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      "MANAGE",
      "MY_CAPACITY",
      null,
      "",
      queryValue,
      APPLICATION_JSON
    ]);
    const capacityList =
      response.data &&
      response.data.getCarrierCapacity &&
      response.data.getCarrierCapacity.capacity
        ? response.data.getCarrierCapacity.capacity
        : [];
    yield put(
      capacityListSuccess({
        capacityList,
        isRefresh
      })
    );
    if (callback) {
      callback(capacityList.length);
    }
    if(isPullToRefresh !== undefined) yield put(hideLoading(isPullToRefresh));
  } catch (e) {
    if(isPullToRefresh !== undefined) yield put(hideLoading(isPullToRefresh));
  }
}

/**
 *  Get Manage Capacity List With Load Count
 *
 * @param action
 */
export function* getManageCapaityListWithLoadCount(action: ActionType): any {
  const {
    query,
    isRefresh,
    isPullToRefresh
  } = action.payload as any;
  try {
    yield put(showLoading(isPullToRefresh));
    const queryValue = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      "MANAGE",
      "MY_CAPACITY",
      null,
      "",
      queryValue,
      APPLICATION_JSON
    ]);
    const capacityList =
      response.data &&
      response.data.getCarrierCapacityWithLoadCount &&
      response.data.getCarrierCapacityWithLoadCount.capacity
        ? response.data.getCarrierCapacityWithLoadCount.capacity
        : [];
    const totalPages =
      response.data &&
        response.data.getCarrierCapacityWithLoadCount &&
        response.data.getCarrierCapacityWithLoadCount.totalPages
        ? response.data.getCarrierCapacityWithLoadCount.totalPages
        : 0;
    const totalRecords =
      response.data &&
        response.data.getCarrierCapacityWithLoadCount &&
        response.data.getCarrierCapacityWithLoadCount.totalRecords
        ? response.data.getCarrierCapacityWithLoadCount.totalRecords
        : 0; 
    yield put(
      capacityListSuccess({
        capacityList,
        isRefresh,
        totalRecords,
        totalPages,
      })
    );
    yield put(hideLoading(isPullToRefresh));
  } catch (e) {
    yield put(hideLoading(isPullToRefresh));
  }
}

/**
 *  get manage capacity loads
 *
 * @param action
 */
export function* getManageCapacityLoads(action: ActionType): any {
  const {
    query,
    callback,
    isPagination = false,
    showLoader = false
  } = action.payload as any;
  try {
    if (showLoader) {
      yield put(showLoading());
    }
    const queryValue = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      "MANAGE",
      "MY_CAPACITY",
      null,
      "",
      queryValue,
      APPLICATION_JSON
    ]);
    if (response.data && response.data.getCapacityLoad) {
      const data = response.data.getCapacityLoad || {};
      yield put(getCapacityLoadsSuccess({ data, isPagination }));
    }
    callback && callback();
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
    callback && callback();
  }
}

const formatData = (input: any) => ({
  ...input,
  capacityId: input.capacityId,
  lastUpdatedBy: input.lastUpdatedBy,
  lastUpdatedByEmail: input.userEmail,
  lastUpdatedByPhoneNumber: input.userPhone,
  lastUpdatedDateTime: new Date().toISOString(),
  destination: {
    city: input.destinationCity,
    state: input.destinationState,
    country: input.destinationCountry,
    latitude: input.destinationLatitude,
    longitude: input.destinationLongitude,
    radius: input.destinationRadius
  },
  origin: {
    city: input.originCity,
    state: input.originState,
    country: input.originCountry,
    latitude: input.originLatitude,
    longitude: input.originLongitude,
    radius: input.originRadius
  }
});

/**
 *  Add Manage Capacity List
 *
 * @param action
 */
export function* addManageCapacity(action: ActionType): any {
  const {
    params: { query, input },
    callback
  } = action.payload as any;
  try {
    yield put(showLoading());
    const queryValue = DomainConverter.dataToMutation<any>(query, input);
    const response = yield call(request, [
      "MANAGE",
      "MY_CAPACITY",
      null,
      "",
      queryValue,
      APPLICATION_JSON
    ]);
    
    callback(!!response.data);
    yield put(hideLoading());
  } catch (e) {
    callback();
    yield put(hideLoading());
  }
}

/**
 *  Add Manage Capacity List
 *
 * @param action
 */
export function* updateManageCapacity(action: ActionType): any {
  const {
    params: { query, input, lastUpdatedBy },
    callback
  } = action.payload as any;
  try {
    yield put(showLoading());
    const queryValue = DomainConverter.dataToMutation<any>(query, input);
    const response = yield call(request, [
      "MANAGE",
      "MY_CAPACITY",
      null,
      "",
      queryValue,
      APPLICATION_JSON
    ]);
    if (response.data && response.data.updateCarrierCapacity) {
      yield put(
        manageCapacityUpdateSuccess({
          capacityItem: formatData({
            ...input,
            lastUpdatedBy
          })
        })
      );
    }
    callback(!!response.data);
    yield put(hideLoading());
  } catch (e) {
    callback();
    yield put(hideLoading());
  }
}

/**
 *  Delete Manage Capacity List
 *
 * @param action
 */
export function* removeManageCapacity(action: ActionType): any {
  const { query, capacityId, callback } = action.payload as any;
  try {
    yield put(showLoading());
    const queryValue = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      "MANAGE",
      "MY_CAPACITY",
      null,
      "",
      queryValue,
      APPLICATION_JSON
    ]);
    if (response.data && response.data.deleteCarrierCapacity) {
      yield put(manageCapacityRemoveSuccess({ capacityId }));
    }
    callback(!!response.data);
    yield put(hideLoading());
  } catch (e) {
    callback();
    yield put(hideLoading());
  }
}
